import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import FlagIcon from '@mui/icons-material/Flag';
import { createElement } from 'react';

// The app only builds a nav item for a page that has a route ref.
const planningPrioritiesRouteRef = createRouteRef();

export const planningPrioritiesPage = PageBlueprint.make({
  name: 'planning-priorities',
  params: {
    path: '/planning-priorities',
    title: 'Planning Priorities',
    icon: createElement(FlagIcon),
    routeRef: planningPrioritiesRouteRef,
    loader: async () => {
      const { PlanningPrioritiesPage } = await import(
        './PlanningPrioritiesPage'
      );
      return createElement(PlanningPrioritiesPage);
    },
  },
});

export const planningPrioritiesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [planningPrioritiesPage],
});
